import { RootState } from 'store/rootReducer';
import { Auth, defaultAuth } from './types';

export const authSelector = (state: RootState): Auth => {
    if (state?.auth) {
        return state.auth;
    }

    return defaultAuth;
};
